import React, { Component } from 'react';
import { asyncConnect } from 'redux-connect';
import { translate } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';

import { createDefaultPromise } from 'utils';
import { allCountriesSelector } from 'selectors';
import { loadAllCountries, registerCompany, searchCity, login } from 'actions';
import CitySearchField from 'widgets/CitySearchField';
import I18nLink from 'widgets/I18nLink';
import { createValidator } from 'utils/validate';

import {
  defaultValidateHandler,
  defaultValidateStatus,
  defaultOnChange,
  defaultOnCheckboxChange,
  defaultOnBlur
} from 'utils/form';

import './company-page.css';

class CompanyPage extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      countriesOptions: [],
      name: '',
      country: null,
      city: null,
      searchState: { cityString: '', cityTitle: '' },
      email: '',
      password: '',
      passwordConfirm: '',
      termsOfAgreement: false,
      errors: {}
    };

    this.searchCityHandler = this.onSearchCity.bind(this);
    this.cityChangeHandler = this.onCityChange.bind(this);

    this.validateHandler = defaultValidateHandler.bind(this);
    this.validationState = defaultValidateStatus.bind(this);

    this.handleFieldChange = defaultOnChange.bind(this);
    this.handleCheckboxChange = defaultOnCheckboxChange.bind(this);
    this.handleFieldBlur = defaultOnBlur.bind(this);
  }

  componentWillMount() {
    const { t, countries } = this.props;

    if (countries) {
      this.generateCountriesOptions(countries);
    }

    const rules = {
      name: {
        minlength: {
          data: 2,
          message: t('Must be at least 2 characters')
        }
      },
      country: {
        required: t('This field may not be blank')
      },
      city: {
        required: t('This field may not be blank')
      },
      email: {
        email: t('Enter valid email address')
      },
      password: {
        minlength: {
          data: 6,
          message: t('Must be at least 6 characters')
        }
      },
      passwordConfirm: {
        equals: t('Passwords must match')
      }
    };

    this.validate = createValidator(rules, { equals: this.validatePasswords });
  }

  validatePasswords = (value, rule) =>
    this.state.password === this.state.passwordConfirm;

  componentWillReceiveProps(nextProps) {
    if (nextProps.countries !== this.props.countries) {
      this.generateCountriesOptions(nextProps.countries);
    }
  }

  generateCountriesOptions(countries) {
    if (!countries) {
      this.setState({
        countriesOptions: [],
        country: null,
        city: null,
        searchState: { cityString: '', cityTitle: '' }
      });

      return;
    }

    const { t } = this.props;
    const countriesOptions = countries.map(country => {
      return {
        title: country.nameEn,
        value: country.id
      };
    }).sort((a, b) => t(a.title, { ns: 'countries' }).trim() < t(b.title, { ns: 'countries' }).trim() ? -1 : 1);

    this.setState({
      countriesOptions,
      country: this.state.country || countriesOptions[0].value
    });
  }

  onSearchCity(q) {
    return this.props.searchCity({ q, country: this.state.country });
  }

  onCityChange(city) {
    this.setState({ city });
    this.validateHandler('city', city);
  }

  onSelect = (key, value) => {
    let newState = { [key]: value };

    if (key === 'country') {
      const params = { city: '', searchState: { cityString: '', cityTitle: '' } };
      newState = Object.assign({}, newState, params);
    }

    this.setState(newState, () => this.validateHandler(key, value));
  };

  getProperties = () => {
    const { name, country, city, email, password, passwordConfirm } = this.state;
    return { name, country, city, email, password, passwordConfirm };
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const isValid = this.validateHandler();
    if (!isValid) {return;}

    const { name, email, password, city } = this.state;

    this.props.registerCompany({ name, email, password, city })
      .then(action => {
        if (action.error) {
          this.setState({ errors: action.error });
        } else if (action.statusCode === 201) {
          const company = action.response.company;
          this.props.login({ username: email, password }, `/profile/companies/${company}/info/`);
        }

        return action;
      }); ;
  };

  render() {
    const { t } = this.props;

    const countriesOptions = this.state.countriesOptions
      .sort((a, b) => t(a.title, { ns: 'countries' }).trim() < t(b.title, { ns: 'countries' }).trim() ? -1 : 1);

    const selectedCountry = this.state.countriesOptions.find(el => el.value === this.state.country);

    return (
      <div className="company-page">
        <Grid>
          <Row>
            <Col lg={12} className="title-block">
              <h1 className="title">{t('Increase your earnings with BikesBooking.com')}</h1>
              <h2 className="subtitle">{t('List your rental company now and receive bookings')}</h2>
            </Col>
            <Col lg={8} md={7} sm={6} xs={12}>
              <div className="custom-list">
                <ul>
                  <li>
                    <b>{t('Global audience of travelers')}</b>
                    <p>{t('We advertise your Rental company to a large audience of travelers worldwide for free, year-round.')}</p>
                  </li>
                  <li>
                    <b>{t('Book scooters, bicycles, ATV\'s and motorcycles from 900+ providers in 42 countries')}</b>
                    <p>{t('It’s really easy to work with us. We will add you in the list of rental companies, so you will start receiving reservations immediately when you will add all info in your account')}.</p>
                  </li>
                  <li>
                    <b>{t('Higher earnings')}</b>
                    <p>{t('You bought these bikes to earn some money, right? They shouldn\'t stay in the garage, with our help your bikes will be always in work and will earn you profits.')}</p>
                  </li>
                  <li>
                    <b>{t('Company account and Extranet system')}</b>
                    <p>{t('Personal account of your company in our Extranet system allows to add bikes with photos and tariffs, manage all your bookings, manage availability and view statistics.')}</p>
                  </li>
                  <li>
                    <b>{t('Do what you know better')}</b>
                    <p>{t('Do what you do professionally - run the rental business and we will take care of online advertisement and bookings - things which we know really well. We will be your new channel of customers.')}</p>
                  </li>
                  <li>
                    <b>{t('We guarantee the Best prices and also Free cancellations in most of the cases')}</b>
                    <p>{t('No registration fees, no monthly fees! Only commission from real and confirmed bookings which we sent you. You even don\'t need to have a bank account, we charge it online. It\'s easy, try it now!')}</p>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={4} md={5} sm={6} xs={12}>
              <form className="company-form" onSubmit={this.handleSubmit}>
                <FormGroup controlId="name" validationState={this.validationState('name')}>
                  <ControlLabel>{t('Company name')}:</ControlLabel>
                  <FormControl
                    name="name"
                    value={this.state.name}
                    onChange={this.handleFieldChange}
                    onBlur={this.handleFieldBlur}
                  />
                  {this.state.errors.name &&
                    <HelpBlock>{this.state.errors.name}</HelpBlock>
                  }
                </FormGroup>

                <FormGroup className="select-form-group">
                  <ControlLabel>{t('Country')}:</ControlLabel>

                  <Dropdown id="searchCountrySelect">
                    <Dropdown.Toggle noCaret>
                      {selectedCountry && t(selectedCountry.title, { ns: 'countries' })}

                      <span className="dropdown-toggle-icon">
                        <span className="caret" />
                      </span>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {countriesOptions.map(el =>
                        <MenuItem
                          key={el.value}
                          eventKey={el.value}
                          active={this.state.country === el.value}
                          bsClass="default"
                          onClick={this.onSelect.bind(this, 'country', el.value)}
                        >
                          {t(el.title, { ns: 'countries' })}
                        </MenuItem>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                  {this.state.errors.country &&
                    <HelpBlock>{this.state.errors.country}</HelpBlock>
                  }
                </FormGroup>

                <FormGroup className="select-form-group" validationState={this.validationState('city')}>
                  <ControlLabel>{t('City')}:</ControlLabel>

                  <CitySearchField
                    id="searchCitySelect"
                    onChange={this.cityChangeHandler}
                    searchCity={this.searchCityHandler}
                    initialState={this.state.searchState}
                  />

                  {this.state.errors.city &&
                    <HelpBlock>{this.state.errors.city}</HelpBlock>
                  }

                  <div className="city-notice">
                    {t("Сan't find your city? Write us an")} <a href="mailto:info@bikesbooking.com">email</a>.
                  </div>
                </FormGroup>

                <FormGroup controlId="email" validationState={this.validationState('email')}>
                  <ControlLabel>{t('Email')}:</ControlLabel>
                  <FormControl
                    name="email"
                    value={this.state.email}
                    onChange={this.handleFieldChange}
                    onBlur={this.handleFieldBlur}
                  />
                  {this.state.errors.email &&
                    <HelpBlock>{this.state.errors.email}</HelpBlock>
                  }
                </FormGroup>

                <FormGroup controlId="password" validationState={this.validationState('password')}>
                  <ControlLabel>{t('Password')}:</ControlLabel>
                  <FormControl
                    name="password"
                    type="password"
                    value={this.state.password}
                    onChange={this.handleFieldChange}
                    onBlur={this.handleFieldBlur}
                  />
                  {this.state.errors.password &&
                    <HelpBlock>{this.state.errors.password}</HelpBlock>
                  }
                </FormGroup>

                <FormGroup controlId="passwordConfirm" validationState={this.validationState('passwordConfirm')}>
                  <ControlLabel>{t('Confirm password')}:</ControlLabel>
                  <FormControl
                    name="passwordConfirm"
                    type="password"
                    value={this.state.passwordConfirm}
                    onChange={this.handleFieldChange}
                    onBlur={this.handleFieldBlur}
                  />
                  {this.state.errors.passwordConfirm &&
                    <HelpBlock>{this.state.errors.passwordConfirm}</HelpBlock>
                  }
                </FormGroup>

                <FormGroup className="checkbox-form-group">
                  <Checkbox
                    className="styled-checkbox"
                    name="termsOfAgreement"
                    checked={this.state.termsOfAgreement}
                    onChange={this.handleCheckboxChange}
                  >
                    <span className="checkbox-icon" />
                    {t('I agree with')} <I18nLink to="/general_delivery_terms/">{t('Terms and Conditions')}</I18nLink>
                  </Checkbox>
                </FormGroup>

                <p className="register-info">
                  {t('By continuing, you agree with General Delivery Terms, register a free account on our website and let us to contact you via email.')}
                </p>

                <Button
                  bsStyle="success"
                  type="submit"
                  className="order-button"
                  disabled={!this.state.termsOfAgreement}
                >
                  {t('Register')}
                </Button>
              </form>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    countries: state.companies.countries.items
  };
}

export default asyncConnect(
  [{ promise: createDefaultPromise(allCountriesSelector, loadAllCountries) }],
  mapStateToProps,
  { registerCompany, searchCity, login }
)(translate(['company', 'translation'])(CompanyPage));



// WEBPACK FOOTER //
// ./src/components/CompanyPage/index.js